import { Avatar, Box } from '@mui/material';
import { use } from 'react';
import { Link } from 'react-router';

import { type ExpertePlanung } from '../../../dtos';
import { BackendConfigContext } from '../../../utils';
import { printName } from './TerminExpertepoolCard.utils';

type ExperteNameCellProps = {
  readonly expertePlanung: ExpertePlanung;
};

export const ExperteNameCell = ({ expertePlanung }: ExperteNameCellProps) => {
  const backendConfig = use(BackendConfigContext);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Avatar sx={{ height: '28px', width: '28px', fontSize: '12px' }}>
        {expertePlanung.experte ? `${expertePlanung.experte.vorname[0]}${expertePlanung.experte.nachname[0]}` : '-'}
      </Avatar>

      <Link target="_blank" rel="noopener" to={`${backendConfig.HiveAppUrl}/experten/${expertePlanung.experteSapId}`}>
        {printName(expertePlanung)}
      </Link>
    </Box>
  );
};
